import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, vShow as _vShow, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@assets/img/icon-update.png'
import _imports_1 from '@/assets/img/Icons/a_file_download.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-93d6c218"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "transactions_section bank_account" }
const _hoisted_2 = {
  key: 0,
  class: "transactions"
}
const _hoisted_3 = { class: "title_box" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = { class: "d-flex mb-3" }
const _hoisted_6 = {
  key: 0,
  class: "option_item m-4"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "icon" }
const _hoisted_10 = { class: "icon" }
const _hoisted_11 = { class: "wrap mb-4 mt-4" }
const _hoisted_12 = { class: "item balance" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "Balance", -1))
const _hoisted_14 = { class: "value" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "item expense" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "Expense", -1))
const _hoisted_19 = { class: "value" }
const _hoisted_20 = {
  key: 0,
  class: "action_sum minus"
}
const _hoisted_21 = {
  key: 1,
  class: "action_sum minus"
}
const _hoisted_22 = { class: "item income mr-auto" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "Income", -1))
const _hoisted_24 = { class: "value" }
const _hoisted_25 = {
  key: 0,
  class: "action_sum"
}
const _hoisted_26 = {
  key: 1,
  class: "action_sum"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_28 = { class: "submenu" }
const _hoisted_29 = { class: "item" }
const _hoisted_30 = { class: "item" }
const _hoisted_31 = {
  key: 1,
  class: "month_review"
}
const _hoisted_32 = { class: "top_line" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_time_icon_svg = _resolveComponent("time-icon-svg")!
  const _component_calendar_icon_svg = _resolveComponent("calendar-icon-svg")!
  const _component_choose_period = _resolveComponent("choose-period")!
  const _component_aba_button = _resolveComponent("aba-button")!
  const _component_transactions_table = _resolveComponent("transactions-table")!
  const _component_datepicker_range = _resolveComponent("datepicker-range")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.IsLoadPerson)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$localization.getTranslate("Transactions")), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.Person?.Balance?.Number), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              (_ctx.Type == 'Card')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("a", {
                      class: "time_btn",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.UpdateCardTransaction && _ctx.UpdateCardTransaction(...args)))
                    }, _hoisted_8)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(["option_item m-4", { active: _ctx.IsPeriod }])
              }, [
                _createElementVNode("a", {
                  class: "time_btn",
                  href: "#",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.IsPeriod = true))
                }, [
                  _createElementVNode("span", _hoisted_9, [
                    _createVNode(_component_time_icon_svg)
                  ])
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["option_item m-4", { active: !_ctx.IsPeriod }])
              }, [
                _createElementVNode("a", {
                  class: "calendar_btn date_picker_btn",
                  href: "#date_picker_popup",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickCalendar && _ctx.clickCalendar(...args)))
                }, [
                  _createElementVNode("span", _hoisted_10, [
                    _createVNode(_component_calendar_icon_svg)
                  ])
                ])
              ], 2)
            ]),
            (_ctx.IsPeriod)
              ? (_openBlock(), _createBlock(_component_choose_period, {
                  key: 0,
                  onSetPeriod: _ctx.ChangePeriod
                }, null, 8, ["onSetPeriod"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  (_ctx.Type === 'Card')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.Card.Balance) + " €", 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.Balance?.Balance) + " €", 1))
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, [
                  (_ctx.Type === 'Card')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.Consumption.toFixed(2)) + " €", 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.ConsumptionInternal.toFixed(2)) + " €", 1))
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, [
                  (_ctx.Type === 'Card')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.Income.toFixed(2)) + " €", 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.IncomeInternal.toFixed(2)) + " €", 1))
                ])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["option_item with_dropdown", { active: _ctx.IsOpenSelectDownload }])
              }, [
                _withDirectives((_openBlock(), _createBlock(_component_aba_button, {
                  class: "active",
                  btnSize: "btnLarge",
                  onClick: _ctx.switchDropdownDownload
                }, {
                  default: _withCtx(() => [
                    _hoisted_27,
                    _createTextVNode("  "),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("Button.DownloadStatement")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])), [
                  [_directive_click_outside, _ctx.closeDropdown]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", {
                      onMousedown: _cache[3] || (_cache[3] = ($event: any) => (_ctx.DownloadTransactions('csv')))
                    }, "csv", 32)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", {
                      onMousedown: _cache[4] || (_cache[4] = ($event: any) => (_ctx.DownloadTransactions('pdf')))
                    }, "pdf", 32)
                  ])
                ], 512), [
                  [_vShow, _ctx.IsOpenSelectDownload]
                ])
              ], 2)
            ]),
            (_ctx.itemsInternal)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    (_ctx.Type === 'Account')
                      ? (_openBlock(), _createBlock(_component_transactions_table, {
                          key: 0,
                          transactions: _ctx.itemsInternal,
                          isLegal: false,
                          paymentsType: _ctx.Person.PaymentsType
                        }, null, 8, ["transactions", "paymentsType"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_datepicker_range, {
      visible: _ctx.isOpenDatepicker,
      onChangeDate: _ctx.ChangeDate,
      onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isOpenDatepicker = false))
    }, null, 8, ["visible", "onChangeDate"])
  ], 64))
}